// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__11VbN","signatureButtonsRight":"ModalSign_signatureButtonsRight__3bhxb"};